module.exports = __webpack_public_path__ + "img/backpack-total-table-icon.8a026729.svg";